// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Liability } from './liability';
import { Transfer } from './transfer';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TransferLiability extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  transferId!: number;
  liabilityId!: number;
  ts!: string;
  liability!: Liability;
  transfer!: Transfer;
}

